import React from 'react';
import "./loaderHO.scss"
const HomeOwnerSpinner = () => <span class="homeOwnerSpinner"></span>;
export default HomeOwnerSpinner;


// WEBPACK FOOTER //
// ./src/components/HomeOwnerSpinner/loader.js